import { brand, neutral, semantic, font } from '../../../theme/tokens';

// Chart styling shared by the Levantamiento charts: neutral gridlines, quiet ticks, Inter.
export const GRID_COLOR = '#eef0f3';
export const TICK_COLOR = neutral[500];
export const LABEL_COLOR = neutral[600];
export const FONT_FAMILY = font.sans;

// Brand-first categorical palette (brand → info → violet → success → warning → danger), then
// lighter/darker variants; cycles if there are more series than colors.
export const SERIES_PALETTE = [
    brand[600],
    semantic.info.solid,
    semantic.violet.solid,
    semantic.success.solid,
    semantic.warning.solid,
    semantic.danger.solid,
    brand[400],
    '#0e9f9a',
    '#a78bfa',
    '#65a30d',
    '#d97706',
    '#db2777',
    brand[800],
    '#155e75',
    '#5b21b6',
    '#047857',
    '#b45309',
    '#9f1239',
    '#38bdf8',
    '#2dd4bf',
    '#c084fc',
    '#84cc16',
    '#fbbf24',
    '#fb7185',
    '#4f46e5',
    '#0891b2',
    '#9333ea',
    '#16a34a',
    '#ea580c',
    neutral[600]
];

export const MARY_COLOR = brand[600];
export const OTHER_COLOR = neutral[400];
export const AVG_LINE_COLOR = semantic.warning.solid;
